import { TeaserData } from "@app/types/ServerCustomContext";
import { configHome } from "@pub/config";
import placeholders from "@pub/placeholders";
import {
  Card,
  ImageCrop,
  NaturalCarousel,
  NaturalCarouselRef,
  ResponsiveImage,
} from "@sphtech/dmg-design-system";
import { useRef, useState } from "react";

import styles from "./fullwidthcarousel.module.css";

type Props = {
  teasers: TeaserData[];
  title: string;
  titleUrl: string;
  backgroundImage?: ImageCrop;
  backgroundLogos?: {
    htmlAnchor: string;
    logoSrc: ImageCrop;
  }[];
  backgroundColor?: string;
  textColor?: string;
};

const FullWidthCarousel = ({
  teasers,
  title,
  titleUrl,
  backgroundImage,
  backgroundLogos,
  backgroundColor,
  textColor,
}: Props) => {
  const carouselRef = useRef<NaturalCarouselRef>(null);
  const [position, setPosition] = useState(0);

  const logoDesktop = backgroundLogos?.find(
    (el) => el.htmlAnchor === "logo-desktop",
  )?.logoSrc;

  // Fallback to logoDesktop if not found
  const logoMobile =
    backgroundLogos?.find((el) => el.htmlAnchor === "logo-mobile")?.logoSrc ??
    logoDesktop;

  const onPositionChange = (newPosition: number) => {
    setPosition(newPosition);
  };

  return (
    <div
      className={styles.backgroundContainer}
      style={{ background: backgroundColor }}
    >
      {backgroundImage && (
        <div className={styles.imageContainer}>
          <ResponsiveImage {...backgroundImage} fill="cover" loading="lazy" />
        </div>
      )}

      <div className={styles.contentContainer}>
        {logoMobile ? (
          <a href={titleUrl} className={styles.logoContainer}>
            <ResponsiveImage
              {...logoMobile}
              mobileUp={logoDesktop}
              fill="contain"
            />
          </a>
        ) : (
          <a href={titleUrl} className={styles.titleContainer}>
            <h2 className={styles.title} style={{ color: textColor }}>
              {title}
            </h2>
          </a>
        )}

        <div className={styles.carouselContainer}>
          <div className={styles.arrowsContainer}>
            {position !== 0 && (
              <button
                onClick={() => carouselRef.current?.previous()}
                className={styles.arrow}
              >
                {configHome.contentBlockCarousel?.leftIcon}
              </button>
            )}
            <button
              onClick={() => carouselRef.current?.next()}
              className={styles.arrow}
            >
              {configHome.contentBlockCarousel?.rightIcon}
            </button>
          </div>

          <NaturalCarousel
            ref={carouselRef}
            isLooping={false}
            hideAllArrows
            onPositionChange={onPositionChange}
          >
            {teasers.map((contentBlockItem, index) => {
              return (
                <div className={styles.cardContainer} key={index}>
                  <Card
                    {...contentBlockItem}
                    variant="card-stacked-portrait"
                    mobileUpVariant="card-stacked-portrait-mobile-up"
                    placeholders={placeholders}
                    displayPublishDate={false}
                    tags={undefined}
                  />
                </div>
              );
            })}
          </NaturalCarousel>
        </div>
      </div>
    </div>
  );
};

export default FullWidthCarousel;
